(() => {
  if (customElements.get('lp-team-shop')) return;
  class TeamShop extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.addEventListener('click', event => {
        const thumbnail = event.target.closest('[data-lp-gallery-image]');
        if (thumbnail) {
          const image = this.querySelector('.lp-shop-image');
          image.removeAttribute('srcset');
          image.src = thumbnail.dataset.lpGalleryImage;
          image.alt = thumbnail.dataset.imageAlt;
          this.querySelectorAll('[data-lp-gallery-image]').forEach(button => button.setAttribute('aria-pressed', String(button === thumbnail)));
        }
        const dialog = this.querySelector('.lp-shop-image-dialog');
        if (event.target.closest('[data-lp-enlarge]') && dialog) {
          const image = this.querySelector('.lp-shop-image');
          dialog.querySelector('img').src = image.currentSrc || image.src;
          dialog.querySelector('img').alt = image.alt;
          dialog.showModal();
        }
        if (event.target.closest('[data-lp-close-image]')) dialog?.close();
        if (event.target === dialog) dialog.close();
      });
      this.addEventListener('change', event => {
        if (event.target.matches('[data-lp-choice]') && !this.purchasing) this.refresh(event.target);
      });
      this.addEventListener('submit', event => {
        if (!event.target.matches('[data-lp-shop-form]')) return;
        event.preventDefault();
        this.add(event.target);
      });
    }
    setMessage(text) { this.querySelector('[data-lp-shop-message]').textContent = text; }
    setError(text = '') {
      const error = this.querySelector('[data-lp-shop-error]');
      error.textContent = text;
      error.hidden = !text;
    }
    async refresh(changed = null, silent = false) {
      this.controller?.abort();
      const controller = new AbortController();
      this.controller = controller;
      const selects = [...this.querySelectorAll('[data-lp-choice]:checked')];
      const target = changed?.dataset.productUrl || this.dataset.productUrl;
      const url = new URL(target, window.location.origin);
      if (url.origin !== window.location.origin) return false;
      url.searchParams.set('section_id', 'lp-team-option-state');
      const values = selects.map(select => select.value);
      if (values.length) url.searchParams.set('option_values', values.join(','));
      const focusId = changed?.id;
      const quantity = this.querySelector('[name="quantity"]')?.value;
      const sizeOpen = this.querySelector('.lp-size-comparisons')?.open;
      this.setAttribute('aria-busy', 'true');
      const submit = this.querySelector('[type="submit"]');
      if (submit) submit.disabled = true;
      this.setError();
      if (!silent) this.setMessage(this.dataset.loading);
      try {
        const response = await fetch(url, {signal:controller.signal,credentials:'same-origin',cache:'no-store'});
        if (!response.ok) throw new Error(this.dataset.error);
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const state = html.querySelector('[data-lp-buy]');
        if (!state || state.dataset.productId !== this.dataset.productId) throw new Error(this.dataset.error);
        if (controller.signal.aborted) return false;
        this.querySelector('[data-lp-buy]').replaceWith(state);
        if (sizeOpen && this.querySelector('.lp-size-comparisons')) this.querySelector('.lp-size-comparisons').open = true;
        const qty = this.querySelector('[name="quantity"]');
        if (qty && qty.type !== 'hidden' && quantity) {
          const min = Number(qty.min || 1);
          const max = Number(qty.max || Infinity);
          const step = Number(qty.step || 1);
          qty.value = String(Math.max(min, Math.min(max, min + Math.floor((Number(quantity) - min) / step) * step)));
        }
        const image = this.querySelector('.lp-shop-image');
        if (image && state.dataset.image) {
          image.removeAttribute('srcset');
          image.src = state.dataset.image;
          image.alt = state.dataset.imageAlt;
          this.querySelectorAll('[data-lp-gallery-image]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.lpGalleryImage.split('?')[0] === state.dataset.image.split('?')[0])));
        }
        if (focusId) this.querySelector('[id="' + CSS.escape(focusId) + '"]')?.focus({preventScroll:true});
        this.setMessage('');
        return true;
      } catch (failure) {
        if (failure.name !== 'AbortError') {
          this.setError(this.dataset.error);
          this.setMessage('');
        }
        return false;
      } finally {
        if (this.controller === controller) this.removeAttribute('aria-busy');
      }
    }
    async add(form) {
      if (this.purchasing || this.hasAttribute('aria-busy') || !form.reportValidity() || form.querySelector('[type="submit"]').disabled) return;
      this.purchasing = true;
      this.querySelectorAll('[data-lp-choice]').forEach(select => select.disabled = true);
      try {
        if (!(await this.refresh(null, true))) return;
        form = this.querySelector('[data-lp-shop-form]');
        const state = this.querySelector('[data-lp-buy]');
        if (!form || state.dataset.available !== 'true') return;
        const submit = form.querySelector('[type="submit"]');
        const originalLabel = submit.textContent;
        submit.disabled = true;
        this.querySelectorAll('[data-lp-choice]').forEach(select => select.disabled = true);
        this.setAttribute('aria-busy', 'true');
        submit.textContent = this.dataset.adding;
        this.setError();
        this.setMessage('');
        const root = window.Shopify?.routes?.root || '/';
        const body = new FormData(form);
        const sectionIds = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(el => el.dataset.sectionId))].slice(0,5);
        if (sectionIds.length) body.set('sections', sectionIds.join(','));
        body.set('sections_url', window.location.pathname);
        try {
          const response = await fetch(root + 'cart/add.js', {method:'POST',body,headers:{Accept:'application/json'},credentials:'same-origin'});
          const result = await response.json();
          if (!response.ok || result.status) throw new Error(result.description || result.message || this.dataset.cartError);
          this.setMessage(this.dataset.added);
          this.querySelector('[data-lp-view-cart]').hidden = false;
          let itemCount = Number(document.querySelector('cart-icon [ref="cartBubbleText"]')?.textContent || 0) + Number(body.get('quantity') || 1);
          try {
            const cartResponse = await fetch(root + 'cart.js', {headers:{Accept:'application/json'},cache:'no-store'});
            if (cartResponse.ok) itemCount = (await cartResponse.json()).item_count;
          } catch (_) {}
          this.dispatchEvent(new CustomEvent('cart:update', {bubbles:true,detail:{resource:result,sourceId:form.id,data:{source:'lp-team-shop',productId:this.dataset.productId,variantId:body.get('id'),itemCount,sections:result.sections}}}));
        } catch (failure) {
          this.setError(failure.message || this.dataset.cartError);
        } finally {
          submit.disabled = false;
          submit.textContent = originalLabel;
        }
      } finally {
        this.purchasing = false;
        this.removeAttribute('aria-busy');
        this.querySelectorAll('[data-lp-choice]').forEach(select => select.disabled = select.dataset.lpDisabled === 'true');
      }
    }
    disconnectedCallback() { this.controller?.abort(); }
  }
  customElements.define('lp-team-shop', TeamShop);
})();
